import React, { useEffect, useRef, useState } from "react";

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800;900&family=Cinzel:wght@600;700;900&family=Inter:wght@300;400;500;600&display=swap');

  :root {
    --teal: #0F766E; --teal-dark: #0D5E57; --teal-mid: #14B8A6;
    --teal-light: #2DD4BF; --teal-pale: #CCFBF1; --teal-faint: #F0FDFA;
    --white: #FFFFFF; --off-white: #F8FAFC;
    --text: #0F172A; --text-mid: #334155; --text-muted: #64748B;
    --border: #E2E8F0;
    --shadow: 0 4px 24px rgba(15,118,110,0.10);
    --shadow-lg: 0 12px 48px rgba(15,118,110,0.16);
  }

  .lp-wrap * { box-sizing: border-box; margin: 0; padding: 0; }
  .lp-wrap { font-family: 'Inter', sans-serif; color: var(--text); overflow-x: hidden; }
  .lp-brand { font-family: 'Cinzel', serif !important; letter-spacing: 0.05em; }

  /* NAV */
  .lp-nav { position: fixed; top: 0; left: 0; right: 0; z-index: 9999; background: rgba(255,255,255,0.92); backdrop-filter: blur(14px); border-bottom: 1px solid rgba(14,116,144,0.10); transition: box-shadow 0.3s; }
  .lp-nav.scrolled { box-shadow: 0 2px 20px rgba(15,118,110,0.10); }
  .lp-nav-inner { max-width: 1160px; margin: 0 auto; padding: 0 32px; height: 68px; display: flex; align-items: center; justify-content: space-between; }
  .lp-nav-logo { font-family: 'Cinzel', serif; font-size: 17px; font-weight: 700; color: var(--teal); letter-spacing: 0.06em; text-decoration: none; background: none; border: none; cursor: pointer; }
  .lp-nav-links { display: flex; align-items: center; gap: 36px; list-style: none; }
  .lp-nav-links a { text-decoration: none; font-size: 14px; font-weight: 500; color: var(--text-mid); transition: color 0.2s; position: relative; }
  .lp-nav-links a::after { content: ''; position: absolute; bottom: -3px; left: 0; right: 0; height: 2px; background: var(--teal-mid); transform: scaleX(0); transition: transform 0.22s ease; border-radius: 2px; }
  .lp-nav-links a:hover { color: var(--teal); }
  .lp-nav-links a:hover::after { transform: scaleX(1); }
  .lp-nav-actions { display: flex; align-items: center; gap: 12px; }
  .lp-btn-ghost { padding: 9px 20px; border-radius: 10px; border: 1.5px solid var(--teal); background: transparent; color: var(--teal); font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .lp-btn-ghost:hover { background: var(--teal-faint); }
  .lp-btn-primary { padding: 9px 22px; border-radius: 10px; border: none; background: linear-gradient(135deg, var(--teal), var(--teal-mid)); color: #fff; font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.22s; box-shadow: 0 4px 16px rgba(15,118,110,0.22); }
  .lp-btn-primary:hover { transform: translateY(-2px); box-shadow: 0 8px 28px rgba(15,118,110,0.30); }

  /* SUPPORT POPUP MODAL */
  .lp-modal-overlay { position: fixed; inset: 0; background: rgba(15,23,42,0.55); backdrop-filter: blur(4px); z-index: 99999; display: flex; align-items: center; justify-content: center; padding: 24px; animation: lpFadeIn 0.2s ease; }
  @keyframes lpFadeIn { from { opacity: 0; } to { opacity: 1; } }
  .lp-modal { background: var(--white); border-radius: 20px; padding: 40px; width: 100%; max-width: 460px; box-shadow: 0 32px 80px rgba(15,23,42,0.22); animation: lpSlideUp 0.25s ease; position: relative; }
  @keyframes lpSlideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
  .lp-modal-close { position: absolute; top: 16px; right: 16px; width: 32px; height: 32px; border-radius: 8px; border: none; background: var(--off-white); color: var(--text-muted); font-size: 18px; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: all 0.2s; }
  .lp-modal-close:hover { background: var(--border); color: var(--text); }
  .lp-modal-icon { width: 52px; height: 52px; border-radius: 14px; background: linear-gradient(135deg, var(--teal), var(--teal-mid)); display: flex; align-items: center; justify-content: center; font-size: 22px; margin-bottom: 18px; box-shadow: 0 6px 16px rgba(15,118,110,0.22); }
  .lp-modal-title { font-family: 'Outfit', sans-serif; font-size: 22px; font-weight: 800; color: var(--text); margin-bottom: 6px; }
  .lp-modal-sub { font-size: 14px; color: var(--text-muted); margin-bottom: 28px; line-height: 1.6; }
  .lp-modal-field { margin-bottom: 18px; }
  .lp-modal-label { display: block; font-size: 13px; font-weight: 600; color: var(--text-mid); margin-bottom: 7px; }
  .lp-modal-input { width: 100%; padding: 12px 16px; border-radius: 10px; border: 1.5px solid var(--border); font-size: 14px; color: var(--text); background: var(--white); outline: none; transition: border-color 0.2s, box-shadow 0.2s; font-family: 'Inter', sans-serif; }
  .lp-modal-input:focus { border-color: var(--teal-mid); box-shadow: 0 0 0 3px rgba(20,184,166,0.12); }
  .lp-modal-input::placeholder { color: #94A3B8; }
  .lp-modal-select { width: 100%; padding: 12px 16px; border-radius: 10px; border: 1.5px solid var(--border); font-size: 14px; color: var(--text); background: var(--white); outline: none; transition: border-color 0.2s, box-shadow 0.2s; font-family: 'Inter', sans-serif; cursor: pointer; -webkit-appearance: none; appearance: none; background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2364748B' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E"); background-repeat: no-repeat; background-position: right 14px center; padding-right: 40px; }
  .lp-modal-select:focus { border-color: var(--teal-mid); box-shadow: 0 0 0 3px rgba(20,184,166,0.12); }
  .lp-modal-btn { width: 100%; padding: 14px; border-radius: 12px; border: none; background: linear-gradient(135deg, var(--teal), var(--teal-mid)); color: white; font-size: 15px; font-weight: 700; cursor: pointer; transition: all 0.22s; font-family: 'Outfit', sans-serif; margin-top: 8px; box-shadow: 0 6px 20px rgba(15,118,110,0.22); }
  .lp-modal-btn:hover { transform: translateY(-2px); box-shadow: 0 10px 28px rgba(15,118,110,0.30); }
  .lp-modal-btn:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }
  .lp-modal-success { text-align: center; padding: 16px 0 8px; }
  .lp-modal-success-icon { font-size: 52px; margin-bottom: 16px; }
  .lp-modal-success h3 { font-family: 'Outfit', sans-serif; font-size: 22px; font-weight: 800; color: var(--text); margin-bottom: 10px; }
  .lp-modal-success p { font-size: 14px; color: var(--text-muted); line-height: 1.7; }
  .lp-modal-success-btn { margin-top: 24px; padding: 12px 28px; border-radius: 10px; border: 1.5px solid var(--teal); background: transparent; color: var(--teal); font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.2s; font-family: 'Outfit', sans-serif; }
  .lp-modal-success-btn:hover { background: var(--teal-faint); }

  /* HERO */
  .lp-hero { min-height: 100vh; background: linear-gradient(155deg, #F0FDFA 0%, #FAFFFE 45%, #E6FFFD 100%); display: flex; align-items: center; padding: 120px 32px 80px; position: relative; overflow: hidden; }
  .lp-blob { position: absolute; border-radius: 50%; filter: blur(60px); pointer-events: none; }
  .lp-blob-1 { width: 520px; height: 520px; background: radial-gradient(circle, rgba(45,212,191,0.18) 0%, transparent 70%); top: -120px; right: -80px; animation: lpDrift1 12s ease-in-out infinite; }
  .lp-blob-2 { width: 360px; height: 360px; background: radial-gradient(circle, rgba(15,118,110,0.12) 0%, transparent 70%); bottom: 60px; left: -80px; animation: lpDrift2 15s ease-in-out infinite; }
  .lp-blob-3 { width: 220px; height: 220px; background: radial-gradient(circle, rgba(20,184,166,0.14) 0%, transparent 70%); top: 40%; right: 22%; animation: lpDrift1 10s ease-in-out infinite 2s; }
  @keyframes lpDrift1 { 0%,100% { transform: translate(0,0) scale(1); } 50% { transform: translate(24px,20px) scale(1.06); } }
  @keyframes lpDrift2 { 0%,100% { transform: translate(0,0) scale(1); } 50% { transform: translate(-18px,24px) scale(1.04); } }
  .lp-hero-inner { max-width: 1160px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; gap: 60px; align-items: center; position: relative; z-index: 1; width: 100%; }
  .lp-badge { display: inline-flex; align-items: center; gap: 8px; background: var(--teal-pale); color: var(--teal); font-size: 12px; font-weight: 600; letter-spacing: 0.08em; text-transform: uppercase; padding: 6px 16px; border-radius: 100px; margin-bottom: 24px; }
  .lp-badge-dot { width: 7px; height: 7px; border-radius: 50%; background: var(--teal-mid); animation: lpPulseDot 2s ease-in-out infinite; }
  @keyframes lpPulseDot { 0%,100% { opacity: 1; transform: scale(1); } 50% { opacity: 0.6; transform: scale(1.4); } }
  .lp-hero-title { font-family: 'Outfit', sans-serif; font-size: clamp(40px, 5.5vw, 64px); font-weight: 800; line-height: 1.15; color: var(--text); margin-bottom: 20px; letter-spacing: -0.01em; }
  .lp-hl { font-family: 'Cinzel', serif; color: var(--teal); font-weight: 700; display: block; font-size: clamp(32px, 4.5vw, 52px); line-height: 1.2; margin-top: 4px; }
  .lp-hero-desc { font-size: 16px; color: var(--text-muted); line-height: 1.75; max-width: 480px; margin-bottom: 36px; }
  .lp-hero-ctas { display: flex; gap: 14px; align-items: center; flex-wrap: wrap; }
  .lp-btn-hero { padding: 14px 32px; border-radius: 12px; font-size: 15px; font-weight: 600; }
  .lp-btn-outline { padding: 13px 28px; border-radius: 12px; border: 1.5px solid var(--border); background: var(--white); color: var(--text-mid); font-size: 15px; font-weight: 500; cursor: pointer; transition: all 0.2s; display: inline-flex; align-items: center; gap: 8px; }
  .lp-btn-outline:hover { border-color: var(--teal-mid); color: var(--teal); background: var(--teal-faint); }

  /* ORB */
  .lp-orb-wrap { position: relative; width: 420px; height: 420px; animation: lpFloatOrb 6s ease-in-out infinite; display: flex; align-items: center; justify-content: center; }
  @keyframes lpFloatOrb { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-16px); } }
  .lp-orb-ring { position: absolute; border-radius: 50%; border: 1px solid rgba(45,212,191,0.18); }
  .lp-orb-r1 { width: 420px; height: 420px; animation: lpRingSpin 24s linear infinite; }
  .lp-orb-r2 { width: 340px; height: 340px; animation: lpRingSpin 18s linear infinite reverse; border-color: rgba(45,212,191,0.12); }
  .lp-orb-r3 { width: 260px; height: 260px; animation: lpRingSpin 14s linear infinite; border-color: rgba(20,184,166,0.20); }
  @keyframes lpRingSpin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
  .lp-orb-ticker { position: absolute; width: 10px; height: 10px; border-radius: 50%; background: var(--teal-light); box-shadow: 0 0 10px rgba(45,212,191,0.8), 0 0 20px rgba(45,212,191,0.4); top: -5px; left: 50%; transform: translateX(-50%); }
  .lp-orb-r2 .lp-orb-ticker { bottom: -5px; top: auto; background: var(--teal-mid); }
  .lp-orb-r3 .lp-orb-ticker { top: 50%; right: -5px; left: auto; transform: translateY(-50%); background: var(--teal); }
  .lp-orb-center { width: 150px; height: 150px; border-radius: 50%; background: radial-gradient(circle at 38% 32%, #3EDECB 0%, #14B8A6 40%, #0F766E 80%); box-shadow: 0 0 0 12px rgba(45,212,191,0.10), 0 0 0 24px rgba(20,184,166,0.07), 0 0 60px rgba(20,184,166,0.30), inset 0 -10px 30px rgba(0,0,0,0.15), inset 0 10px 20px rgba(255,255,255,0.25); display: flex; align-items: center; justify-content: center; position: relative; z-index: 2; animation: lpOrbPulse 4s ease-in-out infinite; }
  @keyframes lpOrbPulse { 0%,100% { box-shadow: 0 0 0 12px rgba(45,212,191,0.10), 0 0 0 24px rgba(20,184,166,0.07), 0 0 60px rgba(20,184,166,0.30), inset 0 -10px 30px rgba(0,0,0,0.15), inset 0 10px 20px rgba(255,255,255,0.25); } 50% { box-shadow: 0 0 0 18px rgba(45,212,191,0.14), 0 0 0 36px rgba(20,184,166,0.06), 0 0 90px rgba(20,184,166,0.40), inset 0 -10px 30px rgba(0,0,0,0.15), inset 0 10px 20px rgba(255,255,255,0.25); } }
  .lp-orb-inner-ring { width: 80px; height: 80px; border-radius: 50%; border: 2px solid rgba(255,255,255,0.35); position: absolute; animation: lpRingSpin 8s linear infinite; }
  .lp-orb-pulse-dot { width: 18px; height: 18px; border-radius: 50%; background: rgba(255,255,255,0.90); box-shadow: 0 0 12px rgba(255,255,255,0.8); }
  .lp-orb-sat { position: absolute; border-radius: 50%; background: linear-gradient(135deg, rgba(45,212,191,0.9), rgba(20,184,166,0.7)); box-shadow: 0 0 14px rgba(45,212,191,0.5); z-index: 3; }
  .lp-orb-s1 { width: 22px; height: 22px; top: 38px; right: 68px; animation: lpSatPulse 3.5s ease-in-out infinite; }
  .lp-orb-s2 { width: 14px; height: 14px; bottom: 60px; left: 52px; animation: lpSatPulse 4s ease-in-out infinite 1s; background: linear-gradient(135deg, rgba(20,184,166,0.8), rgba(15,118,110,0.7)); }
  .lp-orb-s3 { width: 10px; height: 10px; top: 50%; right: 20px; animation: lpSatPulse 3s ease-in-out infinite 2s; }
  @keyframes lpSatPulse { 0%,100% { opacity: 1; transform: scale(1); } 50% { opacity: 0.5; transform: scale(0.7); } }
  .lp-orb-card { position: absolute; background: rgba(255,255,255,0.95); backdrop-filter: blur(10px); border: 1px solid rgba(20,184,166,0.2); border-radius: 12px; padding: 10px 14px; z-index: 4; box-shadow: 0 8px 24px rgba(15,118,110,0.12); white-space: nowrap; }
  .lp-orb-card-1 { top: 20px; left: 10px; animation: lpCardFloat 5s ease-in-out infinite; }
  .lp-orb-card-2 { bottom: 30px; right: 0px; animation: lpCardFloat 5s ease-in-out infinite 2.5s; }
  @keyframes lpCardFloat { 0%,100% { transform: translateY(0px); } 50% { transform: translateY(-8px); } }
  .lp-card-label { font-size: 10px; font-weight: 600; color: var(--text-muted); text-transform: uppercase; letter-spacing: 0.06em; margin-bottom: 2px; }
  .lp-card-val { font-family: 'Outfit', sans-serif; font-size: 18px; font-weight: 800; color: var(--teal); line-height: 1; }
  .lp-card-sub { font-size: 10px; color: var(--text-muted); margin-top: 1px; }

  /* STATS */
  .lp-stats { background: var(--white); border-top: 1px solid var(--border); border-bottom: 1px solid var(--border); padding: 32px; }
  .lp-stats-inner { max-width: 1160px; margin: 0 auto; display: grid; grid-template-columns: repeat(4,1fr); gap: 16px; text-align: center; }
  .lp-stat { padding: 20px 16px; border-radius: 10px; transition: background 0.2s; }
  .lp-stat:hover { background: var(--teal-faint); }
  .lp-stat-icon { width: 44px; height: 44px; border-radius: 12px; background: var(--teal-pale); display: flex; align-items: center; justify-content: center; margin: 0 auto 12px; color: var(--teal); font-size: 20px; }
  .lp-stat-val { font-family: 'Outfit', sans-serif; font-size: 28px; font-weight: 800; color: var(--teal); line-height: 1; margin-bottom: 4px; letter-spacing: -0.01em; }
  .lp-stat-lbl { font-size: 13px; color: var(--text-muted); font-weight: 500; }

  /* SECTIONS */
  .lp-section { padding: 100px 32px; }
  .lp-section-inner { max-width: 1160px; margin: 0 auto; }
  .lp-tag { display: inline-block; font-size: 12px; font-weight: 600; letter-spacing: 0.10em; text-transform: uppercase; color: var(--teal); background: var(--teal-pale); padding: 5px 14px; border-radius: 100px; margin-bottom: 16px; }
  .lp-sec-title { font-family: 'Outfit', sans-serif; font-size: clamp(30px, 4vw, 44px); font-weight: 800; line-height: 1.2; color: var(--text); letter-spacing: -0.01em; margin-bottom: 14px; }
  .lp-sec-sub { font-size: 16px; color: var(--text-muted); max-width: 560px; line-height: 1.7; }
  .lp-sec-head { margin-bottom: 60px; text-align: center; }
  .lp-sec-head .lp-sec-sub { margin: 0 auto; }
  .lp-divider { width: 44px; height: 3px; background: linear-gradient(90deg, var(--teal), var(--teal-light)); border-radius: 2px; margin: 16px auto 0; }

  /* FEATURES */
  .lp-feat-bg { background: var(--off-white); }
  .lp-feat-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 24px; }
  .lp-feat-card { background: var(--white); border-radius: 16px; padding: 36px; border: 1px solid var(--border); transition: all 0.28s ease; position: relative; overflow: hidden; }
  .lp-feat-card::before { content: ''; position: absolute; top: 0; left: 0; right: 0; height: 3px; background: linear-gradient(90deg, var(--teal), var(--teal-light)); transform: scaleX(0); transition: transform 0.3s ease; transform-origin: left; }
  .lp-feat-card:hover { box-shadow: var(--shadow-lg); transform: translateY(-4px); border-color: rgba(20,184,166,0.3); }
  .lp-feat-card:hover::before { transform: scaleX(1); }
  .lp-feat-icon { width: 54px; height: 54px; border-radius: 14px; background: linear-gradient(135deg, var(--teal-faint), var(--teal-pale)); display: flex; align-items: center; justify-content: center; font-size: 24px; margin-bottom: 22px; transition: transform 0.2s; }
  .lp-feat-card:hover .lp-feat-icon { transform: scale(1.08); }
  .lp-feat-title { font-family: 'Outfit', sans-serif; font-size: 19px; font-weight: 700; color: var(--text); margin-bottom: 10px; }
  .lp-feat-desc { font-size: 14px; color: var(--text-muted); line-height: 1.72; }
  .lp-feat-tags { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 18px; }
  .lp-feat-tag { font-size: 12px; font-weight: 500; color: var(--teal); background: var(--teal-pale); padding: 4px 12px; border-radius: 100px; }

  /* PRICING */
  .lp-price-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 28px; align-items: start; }
  .lp-price-card { background: var(--white); border: 1.5px solid var(--border); border-radius: 20px; padding: 44px 40px; position: relative; transition: all 0.28s ease; }
  .lp-price-card:hover { box-shadow: var(--shadow-lg); transform: translateY(-4px); }
  .lp-price-card.lp-featured { background: linear-gradient(160deg, #0F766E 0%, #0D6E65 100%); border-color: transparent; transform: scale(1.04); box-shadow: 0 24px 64px rgba(15,118,110,0.30); z-index: 2; }
  .lp-price-card.lp-featured:hover { transform: scale(1.04) translateY(-4px); }
  .lp-pop-badge { position: absolute; top: -14px; left: 50%; transform: translateX(-50%); background: linear-gradient(90deg, #14B8A6, #2DD4BF); color: white; font-size: 12px; font-weight: 700; letter-spacing: 0.06em; text-transform: uppercase; padding: 5px 20px; border-radius: 100px; white-space: nowrap; box-shadow: 0 4px 16px rgba(20,184,166,0.40); }
  .lp-plan-name { font-family: 'Outfit', sans-serif; font-size: 15px; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase; color: var(--teal); margin-bottom: 16px; }
  .lp-featured .lp-plan-name { color: rgba(255,255,255,0.70); }
  .lp-plan-price { display: flex; align-items: flex-end; gap: 3px; margin-bottom: 8px; line-height: 1; }
  .lp-price-cur { font-family: 'Outfit', sans-serif; font-size: 26px; font-weight: 700; color: var(--text-mid); padding-bottom: 8px; }
  .lp-price-amt { font-family: 'Outfit', sans-serif; font-size: 72px; font-weight: 900; color: var(--text); line-height: 1; letter-spacing: -0.03em; }
  .lp-price-per { font-size: 14px; color: var(--text-muted); font-weight: 500; padding-bottom: 10px; margin-left: 2px; }
  .lp-featured .lp-price-cur, .lp-featured .lp-price-amt, .lp-featured .lp-price-per { color: white; }
  .lp-plan-desc { font-size: 14px; color: var(--text-muted); margin-bottom: 24px; margin-top: 12px; line-height: 1.65; }
  .lp-featured .lp-plan-desc { color: rgba(255,255,255,0.7); }
  .lp-plan-hr { height: 1px; background: var(--border); margin-bottom: 24px; }
  .lp-featured .lp-plan-hr { background: rgba(255,255,255,0.18); }
  .lp-plan-feats { list-style: none; margin-bottom: 32px; display: flex; flex-direction: column; gap: 13px; }
  .lp-plan-feats li { display: flex; align-items: center; gap: 10px; font-size: 14px; color: var(--text-mid); }
  .lp-featured .lp-plan-feats li { color: rgba(255,255,255,0.85); }
  .lp-check { width: 20px; height: 20px; border-radius: 50%; background: var(--teal-pale); color: var(--teal); display: flex; align-items: center; justify-content: center; font-size: 11px; flex-shrink: 0; font-weight: 700; }
  .lp-featured .lp-check { background: rgba(255,255,255,0.2); color: white; }
  .lp-plan-users { display: flex; align-items: center; gap: 8px; font-size: 13px; color: var(--text-muted); background: var(--teal-faint); padding: 10px 14px; border-radius: 10px; margin-bottom: 20px; font-weight: 500; }
  .lp-featured .lp-plan-users { background: rgba(255,255,255,0.12); color: rgba(255,255,255,0.75); }
  .lp-btn-plan { width: 100%; padding: 15px; border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.22s; border: 1.5px solid var(--teal); background: transparent; color: var(--teal); font-family: 'Outfit', sans-serif; }
  .lp-btn-plan:hover { background: var(--teal-faint); transform: translateY(-1px); }
  .lp-featured .lp-btn-plan { background: white; color: var(--teal); border: none; box-shadow: 0 6px 20px rgba(0,0,0,0.12); }
  .lp-featured .lp-btn-plan:hover { box-shadow: 0 10px 30px rgba(0,0,0,0.18); transform: translateY(-2px); }
  .lp-price-note { text-align: center; margin-top: 36px; font-size: 14px; color: var(--text-muted); }
  .lp-price-note strong { color: var(--teal); font-weight: 600; }

  /* ABOUT */
  .lp-about-bg { background: var(--off-white); }
  .lp-about-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; }
  .lp-about-body { font-size: 15px; color: var(--text-muted); line-height: 1.8; margin-top: 24px; }
  .lp-about-body p + p { margin-top: 16px; }
  .lp-about-stats { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-top: 36px; }
  .lp-astat { background: var(--white); border: 1px solid var(--border); border-radius: 14px; padding: 20px; transition: all 0.2s; }
  .lp-astat:hover { border-color: rgba(20,184,166,0.3); box-shadow: var(--shadow); }
  .lp-astat-val { font-family: 'Outfit', sans-serif; font-size: 30px; font-weight: 800; color: var(--teal); line-height: 1; margin-bottom: 4px; }
  .lp-astat-lbl { font-size: 13px; color: var(--text-muted); }
  .lp-about-right { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
  .lp-acard { background: var(--white); border-radius: 16px; padding: 28px 24px; border: 1px solid var(--border); transition: all 0.25s; }
  .lp-acard:first-child { grid-column: span 2; }
  .lp-acard:hover { box-shadow: var(--shadow-lg); transform: translateY(-3px); border-color: rgba(20,184,166,0.25); }
  .lp-acard-icon { font-size: 28px; margin-bottom: 14px; }
  .lp-acard-title { font-family: 'Outfit', sans-serif; font-size: 16px; font-weight: 700; color: var(--text); margin-bottom: 8px; }
  .lp-acard-desc { font-size: 13px; color: var(--text-muted); line-height: 1.65; }

  /* SUPPORT */
  .lp-support-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 40px; align-items: start; }
  .lp-support-info { display: flex; flex-direction: column; gap: 20px; }
  .lp-contact-card { display: flex; align-items: center; gap: 18px; background: var(--teal-faint); border: 1px solid rgba(20,184,166,0.2); border-radius: 16px; padding: 22px 24px; transition: all 0.22s; }
  .lp-contact-card:hover { box-shadow: var(--shadow); transform: translateX(4px); border-color: rgba(20,184,166,0.4); }
  .lp-contact-icon { width: 52px; height: 52px; border-radius: 14px; background: linear-gradient(135deg, var(--teal), var(--teal-mid)); display: flex; align-items: center; justify-content: center; font-size: 22px; flex-shrink: 0; box-shadow: 0 6px 16px rgba(15,118,110,0.22); }
  .lp-contact-label { font-size: 12px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.08em; color: var(--text-muted); margin-bottom: 4px; }
  .lp-contact-value { font-family: 'Outfit', sans-serif; font-size: 18px; font-weight: 700; color: var(--text); }

  /* ENQUIRY FORM */
  .lp-enquiry-box { background: var(--white); border-radius: 20px; padding: 40px; border: 1px solid var(--border); box-shadow: var(--shadow); }
  .lp-enquiry-box h3 { font-family: 'Outfit', sans-serif; font-size: 22px; font-weight: 800; color: var(--text); margin-bottom: 6px; }
  .lp-enquiry-box p { font-size: 14px; color: var(--text-muted); line-height: 1.65; margin-bottom: 28px; }
  .lp-enq-field { margin-bottom: 18px; }
  .lp-enq-label { display: block; font-size: 13px; font-weight: 600; color: var(--text-mid); margin-bottom: 7px; }
  .lp-enq-input { width: 100%; padding: 12px 16px; border-radius: 10px; border: 1.5px solid var(--border); font-size: 14px; color: var(--text); background: var(--white); outline: none; transition: border-color 0.2s, box-shadow 0.2s; font-family: 'Inter', sans-serif; }
  .lp-enq-input:focus { border-color: var(--teal-mid); box-shadow: 0 0 0 3px rgba(20,184,166,0.12); }
  .lp-enq-input::placeholder { color: #94A3B8; }
  .lp-enq-textarea { width: 100%; padding: 12px 16px; border-radius: 10px; border: 1.5px solid var(--border); font-size: 14px; color: var(--text); background: var(--white); outline: none; transition: border-color 0.2s, box-shadow 0.2s; font-family: 'Inter', sans-serif; resize: vertical; min-height: 100px; }
  .lp-enq-textarea:focus { border-color: var(--teal-mid); box-shadow: 0 0 0 3px rgba(20,184,166,0.12); }
  .lp-enq-textarea::placeholder { color: #94A3B8; }
  .lp-enq-btn { width: 100%; padding: 14px; border-radius: 12px; border: none; background: linear-gradient(135deg, var(--teal), var(--teal-mid)); color: white; font-size: 15px; font-weight: 700; cursor: pointer; transition: all 0.22s; font-family: 'Outfit', sans-serif; box-shadow: 0 6px 20px rgba(15,118,110,0.22); margin-top: 8px; }
  .lp-enq-btn:hover { transform: translateY(-2px); box-shadow: 0 10px 28px rgba(15,118,110,0.30); }
  .lp-enq-success { text-align: center; padding: 24px 0; }
  .lp-enq-success-icon { font-size: 48px; margin-bottom: 14px; }
  .lp-enq-success h4 { font-family: 'Outfit', sans-serif; font-size: 20px; font-weight: 800; color: var(--text); margin-bottom: 8px; }
  .lp-enq-success p { font-size: 14px; color: var(--text-muted); margin-bottom: 0; }

  /* CTA */
  .lp-cta { background: linear-gradient(135deg, #0D5E57 0%, #0F766E 50%, #14B8A6 100%); padding: 80px 32px; text-align: center; position: relative; overflow: hidden; }
  .lp-cta::before { content: ''; position: absolute; top: -60px; right: -60px; width: 300px; height: 300px; border-radius: 50%; background: rgba(255,255,255,0.05); }
  .lp-cta::after { content: ''; position: absolute; bottom: -80px; left: -40px; width: 240px; height: 240px; border-radius: 50%; background: rgba(255,255,255,0.04); }
  .lp-cta-inner { position: relative; z-index: 1; max-width: 640px; margin: 0 auto; }
  .lp-cta-title { font-family: 'Outfit', sans-serif; font-size: clamp(24px, 3.5vw, 38px); font-weight: 800; color: white; margin-bottom: 14px; }
  .lp-cta-desc { font-size: 16px; color: rgba(255,255,255,0.75); margin-bottom: 32px; line-height: 1.7; }
  .lp-cta-btns { display: flex; gap: 14px; justify-content: center; flex-wrap: wrap; }
  .lp-btn-white { padding: 14px 32px; border-radius: 12px; background: white; color: var(--teal); font-size: 15px; font-weight: 700; border: none; cursor: pointer; transition: all 0.22s; box-shadow: 0 6px 24px rgba(0,0,0,0.15); font-family: 'Outfit', sans-serif; }
  .lp-btn-white:hover { transform: translateY(-2px); box-shadow: 0 12px 36px rgba(0,0,0,0.20); }
  .lp-btn-white-ol { padding: 13px 28px; border-radius: 12px; background: transparent; color: white; font-size: 15px; font-weight: 600; border: 1.5px solid rgba(255,255,255,0.4); cursor: pointer; transition: all 0.22s; font-family: 'Outfit', sans-serif; }
  .lp-btn-white-ol:hover { background: rgba(255,255,255,0.10); border-color: rgba(255,255,255,0.7); }

  /* FOOTER */
  .lp-footer { background: #0F172A; padding: 40px 32px; }
  .lp-footer-inner { max-width: 1160px; margin: 0 auto; display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 16px; }
  .lp-footer-logo { font-family: 'Cinzel', serif; font-size: 16px; font-weight: 700; color: #2DD4BF; letter-spacing: 0.06em; }
  .lp-footer-copy { font-size: 13px; color: rgba(255,255,255,0.4); }
  .lp-footer-copy a { color: #2DD4BF; text-decoration: none; }
  .lp-footer-copy a:hover { text-decoration: underline; }
  .lp-footer-links { display: flex; gap: 24px; list-style: none; }
  .lp-footer-links a { font-size: 13px; color: rgba(255,255,255,0.5); text-decoration: none; transition: color 0.2s; }
  .lp-footer-links a:hover { color: #2DD4BF; }

  /* FADE-UP */
  .lp-fu { opacity: 0; transform: translateY(28px); transition: opacity 0.6s ease, transform 0.6s ease; }
  .lp-fu.lp-vis { opacity: 1; transform: translateY(0); }
  .lp-d1 { transition-delay: 0.1s; } .lp-d2 { transition-delay: 0.2s; } .lp-d3 { transition-delay: 0.3s; }

  /* RESPONSIVE — TABLET (max 900px) */
  @media (max-width: 900px) {
    .lp-nav-inner { padding: 0 20px; }
    .lp-nav-links { display: none; }
    .lp-nav-logo { font-size: 14px; }

    .lp-hero { padding: 100px 20px 60px; min-height: auto; }
    .lp-hero-inner { grid-template-columns: 1fr; text-align: center; gap: 32px; }
    .lp-hero-visual { display: none !important; }
    .lp-orb-wrap { display: none !important; }
    .lp-hero-desc { margin: 0 auto 28px; max-width: 100%; }
    .lp-hero-ctas { justify-content: center; flex-direction: column; align-items: center; width: 100%; }
    .lp-btn-hero { width: 100%; text-align: center; justify-content: center; }
    .lp-btn-outline { width: 100%; justify-content: center; }

    .lp-stats { padding: 24px 20px; }
    .lp-stats-inner { grid-template-columns: repeat(2,1fr); gap: 12px; }

    .lp-section { padding: 60px 20px; }

    .lp-feat-grid { grid-template-columns: 1fr; gap: 16px; }
    .lp-feat-card { padding: 24px; }

    .lp-price-grid { grid-template-columns: 1fr; gap: 20px; }
    .lp-price-card { padding: 32px 24px; }
    .lp-price-card.lp-featured { transform: scale(1); }
    .lp-price-amt { font-size: 56px; }

    .lp-about-grid { grid-template-columns: 1fr; gap: 32px; }
    .lp-about-right { grid-template-columns: 1fr; }
    .lp-acard:first-child { grid-column: span 1; }

    .lp-support-grid { grid-template-columns: 1fr; gap: 28px; }

    .lp-cta { padding: 60px 20px; }

    .lp-footer { padding: 32px 20px; }
    .lp-footer-inner { flex-direction: column; align-items: center; text-align: center; gap: 20px; }
    .lp-footer-links { flex-wrap: wrap; justify-content: center; gap: 16px; }
  }

  /* RESPONSIVE — MOBILE (max 480px) */
  @media (max-width: 480px) {
    .lp-nav-inner { padding: 0 16px; height: 60px; }
    .lp-nav-logo { font-size: 13px; }
    .lp-btn-ghost { padding: 7px 14px; font-size: 13px; }
    .lp-btn-primary { padding: 7px 16px; font-size: 13px; }

    .lp-modal { padding: 28px 20px; }
    .lp-modal-title { font-size: 18px; }

    .lp-hero { padding: 90px 16px 52px; }
    .lp-hero-title { font-size: clamp(28px, 8vw, 40px); line-height: 1.18; }
    .lp-hl { font-size: clamp(24px, 7vw, 36px); }
    .lp-hero-desc { font-size: 14px; margin-bottom: 24px; }
    .lp-btn-hero { padding: 13px 24px; font-size: 14px; width: 100%; text-align: center; justify-content: center; }
    .lp-btn-outline { padding: 12px 20px; font-size: 14px; width: 100%; justify-content: center; }
    .lp-hero-ctas { flex-direction: column; width: 100%; gap: 10px; }
    .lp-badge { font-size: 10px; padding: 5px 12px; }

    .lp-stats { padding: 20px 16px; }
    .lp-stats-inner { grid-template-columns: repeat(2,1fr); gap: 10px; }
    .lp-stat { padding: 14px 10px; }
    .lp-stat-val { font-size: 22px; }
    .lp-stat-lbl { font-size: 11px; }
    .lp-stat-icon { width: 36px; height: 36px; font-size: 16px; margin-bottom: 8px; }

    .lp-section { padding: 48px 16px; }
    .lp-sec-title { font-size: clamp(24px, 7vw, 32px); }
    .lp-sec-sub { font-size: 14px; }
    .lp-tag { font-size: 11px; }

    .lp-feat-grid { grid-template-columns: 1fr; gap: 14px; }
    .lp-feat-card { padding: 20px; }
    .lp-feat-title { font-size: 17px; }
    .lp-feat-desc { font-size: 13px; }
    .lp-feat-icon { width: 46px; height: 46px; font-size: 20px; margin-bottom: 16px; }

    .lp-price-grid { grid-template-columns: 1fr; gap: 16px; }
    .lp-price-card { padding: 28px 20px; }
    .lp-price-amt { font-size: 52px; }
    .lp-price-cur { font-size: 20px; }
    .lp-plan-feats li { font-size: 13px; }
    .lp-plan-users { font-size: 12px; }
    .lp-btn-plan { padding: 13px; font-size: 14px; }

    .lp-about-stats { grid-template-columns: 1fr 1fr; gap: 12px; }
    .lp-astat-val { font-size: 24px; }
    .lp-acard { padding: 20px 18px; }
    .lp-acard-title { font-size: 15px; }

    .lp-contact-card { padding: 16px 18px; gap: 14px; }
    .lp-contact-icon { width: 42px; height: 42px; font-size: 18px; }
    .lp-contact-value { font-size: 15px; }

    .lp-enquiry-box { padding: 24px 20px; }
    .lp-enquiry-box h3 { font-size: 18px; }
    .lp-enq-input, .lp-enq-textarea { font-size: 16px; }

    .lp-cta { padding: 48px 16px; }
    .lp-cta-title { font-size: clamp(20px, 6vw, 28px); }
    .lp-cta-desc { font-size: 14px; }
    .lp-btn-white { padding: 13px 24px; font-size: 14px; width: 100%; }
    .lp-btn-white-ol { padding: 12px 20px; font-size: 14px; width: 100%; }
    .lp-cta-btns { flex-direction: column; align-items: center; }

    .lp-footer { padding: 28px 16px; }
    .lp-footer-logo { font-size: 14px; }
    .lp-footer-links { gap: 12px; }
    .lp-footer-copy { font-size: 12px; }
  }
`;

export default function LandingPage({ onLoginClick }) {
  const navRef = useRef(null);
  const [supportModalOpen, setSupportModalOpen] = useState(false);
  const [modalForm, setModalForm] = useState({ companyId: "", enquiryType: "" });
  const [modalSubmitted, setModalSubmitted] = useState(false);

  const [enquiryForm, setEnquiryForm] = useState({ name: "", email: "", company: "", message: "" });
  const [enquirySubmitted, setEnquirySubmitted] = useState(false);

  useEffect(() => {
    const styleEl = document.createElement("style");
    styleEl.id = "lp-styles";
    styleEl.innerHTML = css;
    if (!document.getElementById("lp-styles")) {
      document.head.appendChild(styleEl);
    }
    const handleScroll = () => {
      if (navRef.current) navRef.current.classList.toggle("scrolled", window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add("lp-vis"); }),
      { threshold: 0.12 }
    );
    document.querySelectorAll(".lp-fu").forEach((el) => observer.observe(el));
    return () => {
      window.removeEventListener("scroll", handleScroll);
      observer.disconnect();
    };
  }, []);

  // lock body scroll when modal open
  useEffect(() => {
    document.body.style.overflow = supportModalOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [supportModalOpen]);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const handleModalSubmit = () => {
    if (!modalForm.companyId || !modalForm.enquiryType) return;
    setModalSubmitted(true);
  };

  const handleEnquirySubmit = () => {
    if (!enquiryForm.name || !enquiryForm.email) return;
    setEnquirySubmitted(true);
  };

  const features = [
    { icon: "⚡", title: "Faster Operations", desc: "Track productivity and operational workflows in real time. Spot bottlenecks instantly and keep your entire team moving at peak efficiency with live dashboards and smart alerts.", tags: ["Real-time tracking", "Live dashboards", "Alerts"] },
    { icon: "📊", title: "Smart Reporting", desc: "Generate detailed productivity and performance reports instantly. Export-ready analytics with custom date ranges help admins and managers make data-driven decisions faster.", tags: ["Custom reports", "CSV Export", "Analytics"] },
    { icon: "👥", title: "Team Management", desc: "Manage employees, managers, requests, approvals, and productivity centrally. Role-based views ensure everyone sees exactly what they need — no more, no less.", tags: ["Role-based views", "Approvals", "Employee profiles"] },
    { icon: "🛡", title: "Secure Access", desc: "Role-based authentication with secure, scoped access for admins, managers, and employees. Inactivity timeouts and encrypted sessions keep your data protected around the clock.", tags: ["JWT auth", "Session timeouts", "Encrypted"] },
    { icon: "📂", title: "Production Entry", desc: "Log and review daily production records with ease. Structured entry forms eliminate manual errors and keep billing and operations teams perfectly aligned on every case.", tags: ["Structured forms", "Daily logs", "Error-free"] },
    { icon: "📩", title: "Integrated Inbox", desc: "Internal messaging and notification inbox for every role. Employees, managers, and admins stay in sync with request updates, approvals, and notifications — all in one place.", tags: ["Role inboxes", "Notifications", "Request tracking"] },
  ];

  const plans = [
    { name: "Basic", price: "199", desc: "Perfect for small RCM teams getting started with structured operations tracking.", users: "Up to 30 Users", admins: "1 Admin Account", cta: "Get Started", featured: false, extra: "99.9% Uptime SLA" },
    { name: "Pro", price: "299", desc: "Ideal for growing teams that need more capacity without any feature trade-offs.", users: "Up to 100 Users", admins: "1 Admin Account", cta: "Get Started", featured: true, extra: "Priority Support" },
    { name: "Enterprise", price: "499", desc: "For large organizations and enterprise RCM operations that need full scale.", users: "Up to 1,000 Users", admins: "2 Admin Accounts", cta: "Contact Sales", featured: false, extra: "Dedicated Account Manager" },
  ];

  const commonFeats = [
    "Employee Dashboard & Analytics",
    "Production Entry & Daily Logs",
    "Reports & Export (CSV)",
    "Manager Dashboard & Oversight",
    "Request & Approval Workflows",
    "Role-Based Access Control",
    "Integrated Team Inbox",
    "Profile & Password Management",
  ];

  return (
    <div className="lp-wrap">

      {/* SUPPORT POPUP MODAL */}
      {supportModalOpen && (
        <div className="lp-modal-overlay" onClick={(e) => { if (e.target.classList.contains("lp-modal-overlay")) { setSupportModalOpen(false); setModalSubmitted(false); setModalForm({ companyId: "", enquiryType: "" }); } }}>
          <div className="lp-modal">
            <button className="lp-modal-close" onClick={() => { setSupportModalOpen(false); setModalSubmitted(false); setModalForm({ companyId: "", enquiryType: "" }); }}>✕</button>
            {!modalSubmitted ? (
              <>
                <div className="lp-modal-icon">🎧</div>
                <div className="lp-modal-title">Contact Support</div>
                <div className="lp-modal-sub">Fill in your details and we'll connect you with the right team.</div>
                <div className="lp-modal-field">
                  <label className="lp-modal-label">Company ID</label>
                  <input className="lp-modal-input" placeholder="Enter your Company ID" value={modalForm.companyId} onChange={(e) => setModalForm({ ...modalForm, companyId: e.target.value })} />
                </div>
                <div className="lp-modal-field">
                  <label className="lp-modal-label">Enquiry Type</label>
                  <select className="lp-modal-select" value={modalForm.enquiryType} onChange={(e) => setModalForm({ ...modalForm, enquiryType: e.target.value })}>
                    <option value="" disabled>Select enquiry type</option>
                    <option value="invoice">Invoice Questions</option>
                    <option value="technical">Technical Support</option>
                    <option value="plan">Plan Enquiry</option>
                  </select>
                </div>
                <button className="lp-modal-btn" onClick={handleModalSubmit} disabled={!modalForm.companyId || !modalForm.enquiryType}>Submit Request</button>
              </>
            ) : (
              <div className="lp-modal-success">
                <div className="lp-modal-success-icon">✅</div>
                <h3>Request Submitted!</h3>
                <p>Our support team will reach out to you shortly.<br />You can also email us at <strong>support@geomglobal.com</strong> or call <strong>+91 99513 08350</strong>.</p>
                <button className="lp-modal-success-btn" onClick={() => { setSupportModalOpen(false); setModalSubmitted(false); setModalForm({ companyId: "", enquiryType: "" }); }}>Close</button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* NAV */}
      <nav className="lp-nav" ref={navRef}>
        <div className="lp-nav-inner">
          <button className="lp-nav-logo lp-brand" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
            RCM OPS TRACKER
          </button>
          <ul className="lp-nav-links">
            <li><a href="#about" onClick={(e) => { e.preventDefault(); scrollTo("about"); }}>About Us</a></li>
            <li><a href="#features" onClick={(e) => { e.preventDefault(); scrollTo("features"); }}>Features</a></li>
            <li><a href="#pricing" onClick={(e) => { e.preventDefault(); scrollTo("pricing"); }}>Pricing</a></li>
          </ul>
          <div className="lp-nav-actions">
            <button className="lp-btn-ghost" onClick={() => setSupportModalOpen(true)}>Support</button>
            <button className="lp-btn-primary" onClick={onLoginClick}>Login →</button>
          </div>
        </div>
      </nav>

      {/* HERO */}
      <section className="lp-hero" id="home">
        <div className="lp-blob lp-blob-1" />
        <div className="lp-blob lp-blob-2" />
        <div className="lp-blob lp-blob-3" />
        <div className="lp-hero-inner">
          <div>
            <div className="lp-badge"><span className="lp-badge-dot" />Revenue Cycle Management Platform</div>
            <h1 className="lp-hero-title">
              Streamline Healthcare<br />Operations with
              <span className="lp-hl lp-brand">RCM OPS Tracker</span>
            </h1>
            <p className="lp-hero-desc">
              Manage productivity, monitor employee performance, generate reports, track operations, and optimize healthcare workflows — all in one centralized platform.
            </p>
            <div className="lp-hero-ctas">
              <button className="lp-btn-primary lp-btn-hero" onClick={() => scrollTo("support")}>Get Started →</button>
              <button className="lp-btn-outline" onClick={() => scrollTo("support")}>▶ Book a Demo</button>
            </div>
          </div>
          <div className="lp-hero-visual" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div className="lp-orb-wrap">
              <div className="lp-orb-ring lp-orb-r1"><div className="lp-orb-ticker" /></div>
              <div className="lp-orb-ring lp-orb-r2"><div className="lp-orb-ticker" /></div>
              <div className="lp-orb-ring lp-orb-r3"><div className="lp-orb-ticker" /></div>
              <div className="lp-orb-center">
                <div className="lp-orb-inner-ring" />
                <div className="lp-orb-pulse-dot" />
              </div>
              <span className="lp-orb-sat lp-orb-s1" />
              <span className="lp-orb-sat lp-orb-s2" />
              <span className="lp-orb-sat lp-orb-s3" />
              <div className="lp-orb-card lp-orb-card-1">
                <div className="lp-card-label">Uptime</div>
                <div className="lp-card-val">99.9%</div>
                <div className="lp-card-sub">System Reliability</div>
              </div>
              <div className="lp-orb-card lp-orb-card-2">
                <div className="lp-card-label">Access</div>
                <div className="lp-card-val">24 / 7</div>
                <div className="lp-card-sub">Always Online</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* STATS — replaced 100+ Healthcare Workflows with 15+ Years */}
      <div className="lp-stats">
        <div className="lp-stats-inner">
          {[
            ["○", "99.9%", "System Reliability"],
            ["🕐", "24/7", "Operations Access"],
            ["🏅", "15+", "Years in US Healthcare"],
            ["🔒", "Secure", "Role-Based Access"],
          ].map(([icon, val, lbl], i) => (
            <div className={`lp-stat lp-fu${i > 0 ? ` lp-d${i}` : ""}`} key={lbl}>
              <div className="lp-stat-icon">{icon}</div>
              <div className="lp-stat-val">{val}</div>
              <div className="lp-stat-lbl">{lbl}</div>
            </div>
          ))}
        </div>
      </div>

      {/* ABOUT */}
      <section className="lp-section lp-about-bg" id="about">
        <div className="lp-section-inner">
          <div className="lp-about-grid">
            <div>
              <div style={{ marginBottom: 0 }}>
                <div className="lp-tag">About Us</div>
                <h2 className="lp-sec-title">Built for the RCM Industry, by People Who Understand It</h2>
                <div className="lp-divider" style={{ margin: "16px 0 0" }} />
              </div>
              <div className="lp-about-body lp-fu">
                <p>RCM OPS Tracker was built to solve a real problem — healthcare revenue cycle teams were drowning in spreadsheets, disconnected tools, and manual processes that slowed everything down.</p>
                <p>We created a single platform where every role — from employees logging production to admins managing workflows — has exactly the tools they need to operate efficiently and transparently.</p>
                <p>Developed by <strong style={{ color: "var(--teal)" }}>Geom Global Solutions</strong>, our platform brings enterprise-grade operations management to healthcare teams of every size.</p>
              </div>
              <div className="lp-about-stats lp-fu lp-d1">
                {[["500+", "Teams onboarded"], ["2M+", "Records processed"], ["4", "User role tiers"], ["2026", "Founded"]].map(([v, l]) => (
                  <div className="lp-astat" key={l}><div className="lp-astat-val">{v}</div><div className="lp-astat-lbl">{l}</div></div>
                ))}
              </div>
            </div>
            <div className="lp-about-right lp-fu lp-d1">
              {[
                ["🎯", "Our Mission", "To eliminate inefficiency in healthcare revenue cycle operations by giving every team member a purpose-built platform that makes their work measurable, visible, and fast."],
                ["📈", "Data-Driven", "Every action generates insights. Real-time reports give leaders the clarity to make faster, smarter decisions about their teams and operations."],
                ["🔧", "Constantly Evolving", "We iterate based on real user feedback. New workflows, features, and integrations are shipped regularly to keep your team ahead."],
              ].map(([icon, title, desc]) => (
                <div className="lp-acard" key={title}>
                  <div className="lp-acard-icon">{icon}</div>
                  <div className="lp-acard-title">{title}</div>
                  <p className="lp-acard-desc">{desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section className="lp-section lp-feat-bg" id="features">
        <div className="lp-section-inner">
          <div className="lp-sec-head">
            <div className="lp-tag">Platform Features</div>
            <h2 className="lp-sec-title">Why Teams Choose <span style={{ color: "var(--teal)" }}>RCM OPS Tracker</span></h2>
            <div className="lp-divider" />
            <p className="lp-sec-sub" style={{ marginTop: 16 }}>Everything your healthcare operations team needs — built into one powerful, intuitive platform.</p>
          </div>
          <div className="lp-feat-grid">
            {features.map((f, i) => (
              <div className={`lp-feat-card lp-fu${i % 2 === 1 ? " lp-d1" : ""}`} key={f.title}>
                <div className="lp-feat-icon">{f.icon}</div>
                <div className="lp-feat-title">{f.title}</div>
                <p className="lp-feat-desc">{f.desc}</p>
                <div className="lp-feat-tags">{f.tags.map((t) => <span className="lp-feat-tag" key={t}>{t}</span>)}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PRICING */}
      <section className="lp-section" id="pricing" style={{ background: "var(--white)" }}>
        <div className="lp-section-inner">
          <div className="lp-sec-head">
            <div className="lp-tag">Pricing Plans</div>
            <h2 className="lp-sec-title">Simple, Transparent Pricing</h2>
            <div className="lp-divider" />
            <p className="lp-sec-sub" style={{ marginTop: 16 }}>All plans include every feature. Plans differ only in number of users and admin accounts.</p>
          </div>
          <div className="lp-price-grid">
            {plans.map((p, i) => (
              <div className={`lp-price-card${p.featured ? " lp-featured" : ""} lp-fu${i > 0 ? ` lp-d${i}` : ""}`} key={p.name}>
                {p.featured && <div className="lp-pop-badge">Most Popular</div>}
                <div className="lp-plan-name">{p.name}</div>
                <div className="lp-plan-price">
                  <span className="lp-price-cur">$</span>
                  <span className="lp-price-amt">{p.price}</span>
                  <span className="lp-price-per">/ year</span>
                </div>
                <p className="lp-plan-desc">{p.desc}</p>
                <div className="lp-plan-users">👥 {p.users} &nbsp;·&nbsp; 🔑 {p.admins}</div>
                <div className="lp-plan-hr" />
                <ul className="lp-plan-feats">
                  {[...commonFeats, p.extra].map((feat) => (
                    <li key={feat}><span className="lp-check">✓</span>{feat}</li>
                  ))}
                </ul>
                <button className="lp-btn-plan" onClick={() => scrollTo("support")}>{p.cta}</button>
              </div>
            ))}
          </div>
          <p className="lp-price-note lp-fu"><strong>All features included in every plan.</strong> No hidden charges. Cancel anytime.</p>
        </div>
      </section>

      {/* SUPPORT + ENQUIRY FORM */}
      <section className="lp-section" id="support" style={{ background: "var(--off-white)" }}>
        <div className="lp-section-inner">
          <div className="lp-sec-head">
            <div className="lp-tag">Get In Touch</div>
            <h2 className="lp-sec-title">We're Here to Help</h2>
            <div className="lp-divider" />
            <p className="lp-sec-sub" style={{ marginTop: 16 }}>Have questions or need a demo? Reach out to our team and we'll get back to you quickly.</p>
          </div>
          <div className="lp-support-grid">
            {/* Contact info */}
            <div className="lp-support-info lp-fu">
              <div className="lp-contact-card">
                <div className="lp-contact-icon">✉️</div>
                <div>
                  <div className="lp-contact-label">Email Us</div>
                  <div className="lp-contact-value">support@geomglobal.com</div>
                </div>
              </div>
              <div className="lp-contact-card">
                <div className="lp-contact-icon">📞</div>
                <div>
                  <div className="lp-contact-label">Call Us</div>
                  <div className="lp-contact-value">+91 99513 08350</div>
                </div>
              </div>
              <div className="lp-contact-card">
                <div className="lp-contact-icon">🏢</div>
                <div>
                  <div className="lp-contact-label">Company</div>
                  <div className="lp-contact-value">Geom Global Solutions</div>
                </div>
              </div>
            </div>

            {/* Enquiry form — replaces support hours */}
            <div className="lp-enquiry-box lp-fu lp-d1">
              {!enquirySubmitted ? (
                <>
                  <h3>Book a Demo</h3>
                  <p>Fill in the form below and our team will reach out to schedule a personalized walkthrough.</p>
                  <div className="lp-enq-field">
                    <label className="lp-enq-label">Your Name</label>
                    <input className="lp-enq-input" placeholder="John Smith" value={enquiryForm.name} onChange={(e) => setEnquiryForm({ ...enquiryForm, name: e.target.value })} />
                  </div>
                  <div className="lp-enq-field">
                    <label className="lp-enq-label">Email Address</label>
                    <input className="lp-enq-input" type="email" placeholder="john@company.com" value={enquiryForm.email} onChange={(e) => setEnquiryForm({ ...enquiryForm, email: e.target.value })} />
                  </div>
                  <div className="lp-enq-field">
                    <label className="lp-enq-label">Company Name</label>
                    <input className="lp-enq-input" placeholder="Your company" value={enquiryForm.company} onChange={(e) => setEnquiryForm({ ...enquiryForm, company: e.target.value })} />
                  </div>
                  <div className="lp-enq-field">
                    <label className="lp-enq-label">Message</label>
                    <textarea className="lp-enq-textarea" placeholder="Tell us about your team and what you're looking for..." value={enquiryForm.message} onChange={(e) => setEnquiryForm({ ...enquiryForm, message: e.target.value })} />
                  </div>
                  <button className="lp-enq-btn" onClick={handleEnquirySubmit} disabled={!enquiryForm.name || !enquiryForm.email}>Send Message →</button>
                </>
              ) : (
                <div className="lp-enq-success">
                  <div className="lp-enq-success-icon">🎉</div>
                  <h4>Message Received!</h4>
                  <p>Thanks {enquiryForm.name}! Our team will reach out to you at <strong>{enquiryForm.email}</strong> within 24 hours.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <div className="lp-cta">
        <div className="lp-cta-inner">
          <h2 className="lp-cta-title">Want to see RCM OPS Tracker in action?</h2>
          <p className="lp-cta-desc">Book a personalized demo and explore how our platform can transform your healthcare operations workflow from day one.</p>
          <div className="lp-cta-btns">
            <button className="lp-btn-white" onClick={() => scrollTo("support")}>Book a Demo →</button>
            <button className="lp-btn-white-ol" onClick={onLoginClick}>Login</button>
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <footer className="lp-footer">
        <div className="lp-footer-inner">
          <div className="lp-footer-logo lp-brand">RCM OPS TRACKER</div>
          <ul className="lp-footer-links">
            <li><a href="#about" onClick={(e) => { e.preventDefault(); scrollTo("about"); }}>About Us</a></li>
            <li><a href="#features" onClick={(e) => { e.preventDefault(); scrollTo("features"); }}>Features</a></li>
            <li><a href="#pricing" onClick={(e) => { e.preventDefault(); scrollTo("pricing"); }}>Pricing</a></li>
            <li><a href="#support" onClick={(e) => { e.preventDefault(); scrollTo("support"); }}>Support</a></li>
          </ul>
          <p className="lp-footer-copy">Developed by <a href="https://www.geomhealthcare.com/" target="_blank" rel="noreferrer">Geom Healthcare</a> © 2026</p>
        </div>
      </footer>
    </div>
  );
}
